import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'settings',
	loader: () => ({
		meta: {
			title: 'Settings',
			disabled: true,
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/settings/Layout')).default }),
	children: [
		{
			path: 'website',
			index: true,
			id: 'essentialDocumentWebsite',
			loader: () => ({
				meta: {
					title: 'Website',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/settings/pages/Websites')).default }),
		},
		{
			id: 'essentialDocumentEmailTemplates',
			index: true,
			path: 'templates/email',
			lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/settings/pages/EmailTemplates')).default }),
			loader: () => ({
				meta: {
					title: 'Email Templates',
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'essentialDocumentProducts',
			index: true,
			path: 'products',
			lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/settings/pages/Products')).default }),
			loader: () => ({
				meta: {
					title: 'Products',
					disabled: true,
				} as RouteMeta,
			}),
		},
	],
};
export default route;
